import { Component, Input, OnChanges } from '@angular/core';
import { SluggerService } from '../../../shared/services/slugger.service';

@Component({
    selector: 'cart-row-components',
    templateUrl: './cart.row.components.component.html',
    styleUrls: ['./../../cart.component.scss']
})
export class CartRowComponentsComponent implements OnChanges {
    @Input('components') components: Array<any>;
    public componentizationGroups: Array<any> = [];

    constructor(
        protected slugger: SluggerService
    ) {}

    ngOnChanges() {
        this.groupComponentsByComponentizationGroup();
    }

    private groupComponentsByComponentizationGroup() {
        this.components.forEach(component => {
            let index = this.componentizationGroups
                .findIndex(group => component.group.description === group.description);

            if (index === -1) {
                const componentizationGroup = component.group;
                componentizationGroup.components = [];

                this.componentizationGroups.push(componentizationGroup);
                index = this.componentizationGroups
                    .findIndex(group => component.group.description === group.description);
            }

            this.componentizationGroups[index].components.push(component);
        });
    };
}



// WEBPACK FOOTER //
// /codebuild/output/src2645790472/src/src/app/cart/row/components/cart.row.components.component.ts